export const calculateMultiplier = (limit: number, value: number): number =>
    Math.floor(limit / value);